export const systemConstants = {
    CORRELATION_KEY: 'SSO_APP',
    CSRF_COOKIE_NAME: "idp_csrf-token",
    INITIAL_MINUTES_OTP_TIME: 2,
    INITIAL_SECONDS_OTP_TIME: 0
};